<template>
  <Breadcrumbs main="Paramétricas" title="Tipo Evento" />
  <div class="container-fluid">
    <div class="row project-cards">
      <TopMenu @reload-list-kind-event="reloadList" />
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <SearchInput v-model="searchQuery" placeholder="Buscar por nombre o descripción..." />
          </div>
        </div>
      </div>
      <Table ref="tableRef" :search="searchQuery" />
    </div>
  </div>
</template>

<script>
import TopMenu from "./components/TopMenu.vue";
import Table from "./components/Table.vue";
import SearchInput from "@/components/SearchInput.vue";

export default {
  name: "kindEvent",
  components: {
    TopMenu,
    Table,
    SearchInput,
  },
  data() {
    return {
      searchQuery: "",
    };
  },
  methods: {
    reloadList() {
      this.$refs.tableRef.loadItems();
    },
  },
};
</script>

